export default "__VITE_ASSET__CnqN984B__"